module.exports = __webpack_public_path__ + "img/bplus-home-sg.ffa36da8.png";